<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>


<script>
import {applyResponsiveScaling} from '@/unitls/detectZoom'

export default {
  name: 'App',
  mounted() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      console.log('当前在手机端');
    } else {
      // 应用缩放调整
      applyResponsiveScaling();

// 当窗口大小改变时重新应用
      window.addEventListener('resize', applyResponsiveScaling);
    }

  },
}
</script>

<style>
#app {
  background-color: rgba(244, 244, 244, 1);
  max-width: 100%;
}

/* 定义进入和离开的过渡状态 */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active for <=2.1.8 */
{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue